<template>
  <v-card min-height="350" class="flexcard" hover>
    <v-card-title class="headline justify-center">
      {{plan.title}}
    </v-card-title>
    <v-card-text class="grow text-xs-center">
        <v-layout justify-center>
          <v-flex xs6 sm7 md6>
            <v-text-field
              v-money="config"
              v-model.lazy="price"
              prefix="R$"
              outline
              label="Valor"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
      <v-list>
        <v-list-tile v-for="item in plan.items" :key="item.text">
          <v-list-tile-avatar>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title 
              :style="[!item.include?{'text-decoration':'line-through'}:'']">
              {{item.text}}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <span class="red--text" v-if="error">{{error}}</span>
      <template v-if="errorArray">
        <span class="red--text" v-for="(er,index) in errorArray" :key="index">
          {{er.description}}
        </span>
      </template>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn color="success" :loading="loading" :disabled="loading" large @click="subscription">Escolher</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Axios from 'axios'

export default {
  props:['plan'],
  data:()=>({
    config: {decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2},
    loading:false,
    price:"113.00",
    error:null,
    errorArray:[]
  }),
  methods:{
    async subscription(){
      try {
        this.loading = true
        const res = await this.$store.dispatch('linkrestaurant')
        if(res.data.ok || this.$store.state.restaurant.external_reference){
          const res2 = await this.$store.dispatch('subscription',{code:this.plan.code,price:this.price})
          if(res2.data.ok){
            const redirect = await Axios.get(`/firstBill/${res2.data.data.id}`)
            window.open(redirect.data.data[0].invoiceUrl)
          }else if(res2.data.data){
            this.errorArray = res2.data.data.errors
          }else{
            this.error = res2.data.error || "Algo inesperado aconteceu."
          }
        }else{
          this.error = res.data.error
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .flexcard {
      display: flex;
      flex-direction: column;
  }
</style>